import TodoFolderView from '../store/schema/TodoFolderView';
import { TodoPanelSource } from '../store/schema/TodoPanelSource';
import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import { Datapoints } from '../datapoints';
import { GetTodoSettingResponse } from '../services/GetTodoSettingServiceResponse';

export const setSelectedFolderId = action('setSelectedFolderId', (folderId: string) => ({
    folderId: folderId,
}));

export const switchFolder = action('switchFolder', (folderId: string) =>
    addDatapointConfig(Datapoints.todoPanelActionChangeFolder.datapoint(), {
        folderId: folderId,
    })
);

export const setSelectedFolderView = action(
    'setSelectedFolderView',
    (todoFolderView: TodoFolderView) => ({
        todoFolderView,
    })
);

export const loadPanel = action('loadPanel', (source: TodoPanelSource) => ({ source }));

export const panelLoaded = action('todoPanelLoaded', () =>
    addDatapointConfig(Datapoints.todoPanelActionOpen.datapoint())
);

export const loadSettings = action('loadTaskSettings');
export const settingsLoaded = action('taskSettingsLoaded', (settings: GetTodoSettingResponse) => ({
    settings,
}));
export const turnOnFlaggedEmailList = action('turnOnFlaggedEmailList');

export const initializePanelTelemetryData = action(
    'initializePanelTelemetryData',
    (source: TodoPanelSource) => ({ source })
);

export const panelClosed = action('panelClosed', () =>
    addDatapointConfig(Datapoints.todoPanelActionClose.datapoint())
);
